import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { slackQueryKeys } from "./slackQueryKeys";

/** The org's outbound allowlist across every connected workspace. Readable by any org member. */
export function useSlackOutboundChannels(orgId?: string) {
  const { slackService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: slackQueryKeys.outboundChannels(resolvedOrgId),
    queryFn: ({ signal }) =>
      slackService.listOutboundChannels(resolvedOrgId, { abortSignal: signal }),
    staleTime: 30_000,
  });
}
